import s from "./index49.js";
import f from "./index59.js";
import r from "./index73.js";
function d(o, i) {
  return f(o, new r.classes.URLSearchParams(), {
    visitor: function(t, a, n, e) {
      return r.isNode && s.isBuffer(t) ? (this.append(a, t.toString("base64")), !1) : e.defaultVisitor.apply(this, arguments);
    },
    ...i
  });
}
export {
  d as default
};
